import { c as _c } from "react/compiler-runtime";
import { isDate } from 'date-fns';
import { Chips, DatePicker, Separator, useTranslationContext } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { getApiDateString, isApiDateString, parseDate, suffixTestId } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
import { getFilterFieldName } from '../../utils/getFilterFieldName';
import { parseDateFilter } from '../../utils/parseDateFilter';
export type DateFilterProps = EagFilterProps & {
  min: string | null;
  max: string | null;
  relativeDates: Array<{
    value: string;
    label: string;
  }>;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function DateFilter(props) {
  const $ = _c(39);
  const t = useTranslationContext();
  let t0;
  if ($[0] !== props.min) {
    t0 = parseDateFilter(props.min);
    $[0] = props.min;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const minDate = t0;
  let t1;
  if ($[2] !== props.max) {
    t1 = parseDateFilter(props.max);
    $[2] = props.max;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const maxDate = t1;
  const model = props.value[FILTER_VALUE_KEY] as string | null ?? null;
  let t2;
  if ($[4] !== props) {
    t2 = filterModel => {
      const newModel = isDate(filterModel) ? getApiDateString(filterModel) : filterModel;
      props.onChange({
        [FILTER_VALUE_KEY]: newModel
      });
    };
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setFilterValue = t2;
  let t3;
  if ($[6] !== setFilterValue) {
    t3 = {
      setFilterValue,
      defaultValue: null
    };
    $[6] = setFilterValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    onChipsChange
  } = useFilterOnChipsChange(t3);
  let t4;
  if ($[8] !== model) {
    t4 = isApiDateString(model) ? parseDate(model) : null;
    $[8] = model;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const datePickerValue = t4;
  let t5;
  if ($[10] !== model) {
    t5 = typeof model === "string" ? [model] : [];
    $[10] = model;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const chipsValue = t5;
  let t6;
  if ($[12] !== model) {
    t6 = intersection([model], quickFiltersConst);
    $[12] = model;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const isQuickFilterValue = t6 as string[];
  let t7;
  if ($[14] !== isQuickFilterValue || $[15] !== onChipsChange || $[16] !== props) {
    t7 = props.quickFilters && props.quickFilters.length > 0 && <><HStack><Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId("date-filter-quickFilters", props)} isDeselectable={true} /></HStack><Separator spacing={0} /></>;
    $[14] = isQuickFilterValue;
    $[15] = onChipsChange;
    $[16] = props;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== chipsValue || $[19] !== onChipsChange || $[20] !== props) {
    t8 = props.relativeDates && props.relativeDates.length > 0 && <Chips isDisabled={props.isDisabled} value={chipsValue} options={props.relativeDates} onChange={onChipsChange} data-testid={suffixTestId("date-filter-relativeDates", props)} isDeselectable={true} />;
    $[18] = chipsValue;
    $[19] = onChipsChange;
    $[20] = props;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = props.isDisabled;
  let t10;
  if ($[22] !== props.column || $[23] !== t) {
    t10 = t("page.datagrid.filter.datePlaceholder", {
      field: getFilterFieldName(props.column)
    });
    $[22] = props.column;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== props) {
    t11 = suffixTestId("date-filter", props);
    $[25] = props;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== datePickerValue || $[28] !== maxDate || $[29] !== minDate || $[30] !== props.isDisabled || $[31] !== setFilterValue || $[32] !== t10 || $[33] !== t11) {
    t12 = <DatePicker isDisabled={t9} placeholder={t10} value={datePickerValue} onChange={setFilterValue} minDate={minDate} maxDate={maxDate} data-testid={t11} />;
    $[27] = datePickerValue;
    $[28] = maxDate;
    $[29] = minDate;
    $[30] = props.isDisabled;
    $[31] = setFilterValue;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t7 || $[37] !== t8) {
    t13 = <VStack spacing={4}>{t7}{t8}{t12}</VStack>;
    $[35] = t12;
    $[36] = t7;
    $[37] = t8;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}